import React from 'react';
import {useTranslation} from 'react-i18next';
import {IElement} from '../../../../incase-domain/elements';
import useFontOptions from '../../../../hooks/useFontOptions';
import DropdownMenuCompact from '../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Button from '../../../../incase-domain/components/button/Button';
import Label from '../../../../incase-domain/components/label/Label';

interface FontSelectProps {
    highlightedElement: IElement;
    highlightedElementChangeHandler: {
        single: (field: keyof IElement, value: unknown) => void;
    };
}

export default function FontSelect(props: FontSelectProps): JSX.Element {
    const {highlightedElement, highlightedElementChangeHandler} = props;

    const {t} = useTranslation();
    const fontOptions = useFontOptions();

    const fontItems = [
        fontOptions.map((el) => ({
            label: el.label,
            font: {
                name: el.label.toString(),
                url: el.value.toString(),
            },
            onClick: () =>
                highlightedElementChangeHandler.single('fontFamily', {
                    name: el.label,
                    url: el.value,
                }),
        })),
    ];

    return (
        <div className="u-flex u-v-center u-h-between u-gap-4">
            <Label>{t('designSidepanel.font')}</Label>
            <DropdownMenuCompact items={fontItems}>
                <Button size="sm" variant="soft" trailing="solar:alt-arrow-down-linear" fullWidth className="c-sidepanel__dropdown_button">
                    {fontOptions.find((option) => option.label === highlightedElement.fontFamily?.name)?.label}
                </Button>
            </DropdownMenuCompact>
        </div>
    );
}
